// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchTypeSelectVertical-module__wrapper___0nl5q"};